import { FlowStageCell } from 'components/Flow/FlowStageCell';
import { cellTypesEnum } from 'BaseComponents';



export const getColumns = () => ([{
  field: 'displayID',
  name: 'Display ID',
  width: 130,
  valueGetter: ({ row }) => (row?.flow?.displayID),
}, {
  field: 'Name',
  name: 'Name',
  width: 280,
  type: cellTypesEnum.LINE_3,
  valueGetter: ({ row }) => (row?.flow?.name),
}, {
  field: 'stage',
  name: 'Stage',
  width: 70,
  component: FlowStageCell,
}, {
  field: 'description',
  name: 'Description',
  width: 280,
  type: cellTypesEnum.LINE_5,
  valueGetter: ({ row }) => (row?.flow?.description),
}, {
  field: 'Created On',
  name: 'Date Created',
  width: 140,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.createdAt),
}, {
  field: 'Date Motified',
  name: 'Date Motified',
  width: 140,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.updatedAt),
},
{
  field: 'Runs',
  name: 'Runs',
  width: 70,
  type: cellTypesEnum.LINE_2,
  valueGetter: ({ row }) => (row?.runCount),
},
{
  field: 'ID',
  name: 'Clean Room Flow ID',
  width: 200,
  type: cellTypesEnum.LINE_2,
  valueGetter: ({ row }) => (row?.ID),
},
]);
